// --------------------------------------------------------
// OMS QUESTION - OMSQuestion
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import React, { useEffect, useState } from 'react'
import useResponsiveInfo from '../../hooks/useResponsiveInfo'
import { QuestionBody, QuestionContainer, QuestionNumberContainer, QuestionOption, QuestionOptionContainer, QuestionOptionText, ScaleContainer, ScaleInfoContainer, ScaleInfoText } from './OMSQuestionnaire.styled'
import { Text } from '../../components/UI/generalLayout/Layout.styled';
import { useAppDispatch } from '../..';
import LabelInput from '../../components/labelInput/LabelInput';
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// OMS QUESTION INTERFACE
// --------------------------------------------------------

interface IOMSQuestion {
    scalesLabel: any[];
    perguntas: any[];
    questionario: any
    isDemo?: boolean;
    isNoneSelected?: boolean;
    setAllAnswers: any;
    setTextAnswers: any;
    isView: boolean;
    respostas?: any[];
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const OMSQuestion = ({ isView, scalesLabel, perguntas, respostas = [], isDemo = false, isNoneSelected = false, setAllAnswers, setTextAnswers }: IOMSQuestion) => {
    // --------------------------------------------------------
    // OMS QUESTION PRIVATE DECLARATIONS
    // --------------------------------------------------------
    const { isMobile } = useResponsiveInfo()
    const [textAnswer, setTextAnswer] = useState('')
    const [answers, setAnswers] = useState(Array(perguntas.length).fill(''));

    useEffect(()=>{
        if(scalesLabel.length === 0 && respostas.length > 0){
            const resposta = respostas.filter(r=> r.perguntaId === perguntas[0].id)
            setTextAnswer(resposta[0].valor)
        }
    }, [scalesLabel, respostas])

    const onClickOption = (value: any, index: number, questionId: string)=>{
        const list = [...answers]
        list.splice(index, 1)
        list.splice(index, 0, {questionId: questionId, ...value})
        setAnswers(list)

        setAllAnswers((prev: any)=>{
            const index = prev.findIndex((el: any)=>{
                return el.questionId === questionId
            })
            if(index !== -1){
                prev.splice(index, 1)
                prev.splice(index, 0, {questionId: questionId, ...value})
            }else{
                prev.push({questionId: questionId, ...value})
            }

            return [...prev];
        })
    }

    const onTextAnswerChange = (value: string, id: string)=>{
        setTextAnswer(value); 
        setTextAnswers((prev: any)=>{
            const index = prev.findIndex((el: any)=>{
                return el.questionId === id
            })
            if(value !== ''){
                if(index !== -1){
                    prev.splice(index, 1)
                    prev.splice(index, 0, {questionId: id, text: value})
                }else{
                    prev.push({questionId: id, text: value})
                }
            }else{
                prev.splice(index, 1)
            }

            return [...prev];
        })
    }

    const isOptionSelected = (value: any, index: number, perguntaId: string)=>{
        let codigo;
        let codigoValue;
        if(isView){
            const resposta = respostas.filter(r=> r.perguntaId === perguntaId);
            if(resposta.length > 0){
                codigo = resposta[0].valor
                codigoValue = value.codigo
            }
        }else{
            codigo = answers[index] !== ''? answers[index].codigo : ''
            codigoValue = value.codigo
        }

        return codigo === codigoValue
    }

    // --------------------------------------------------------
    // REACT RETURN FUNCTION
    // --------------------------------------------------------
    return (
        <>            
            {!isMobile && (<div>
                <ScaleContainer>
                    {scalesLabel.map(scale=>{
                        return <ScaleInfoContainer>
                        <ScaleInfoText>{scale.texto} </ScaleInfoText>
                    </ScaleInfoContainer>
                    })}
                </ScaleContainer>

                {perguntas.map((p: any, index: number)=>{
                return <>{scalesLabel.length > 0 ? (<QuestionContainer>
                    <QuestionNumberContainer>
                        <Text style={{ color: '#575757' }}>{`${p.numero < 10? '0'+p.numero : p.numero}.`}</Text>
                    </QuestionNumberContainer>
                    <QuestionBody>
                        <Text style={{ fontSize: 14, color: '#575757' }}>{p.pergunta}</Text>
                    </QuestionBody>
                    <QuestionOptionContainer>
                    {scalesLabel.map(answer=>{
                            return (
                            <QuestionOption 
                                onClick={(isDemo || isView)? ()=>{}:()=>{ onClickOption(answer, index, p.id)}} 
                                selected={isNoneSelected? false : (isDemo? (answer.codigo === '4'? true : false) : isOptionSelected(answer, index, p.id))} isDemo={isDemo} isView={isView}>
                            <QuestionOptionText>{answer.codigo}</QuestionOptionText>
                        </QuestionOption>)
                        })}
                    </QuestionOptionContainer>
                </QuestionContainer>):(
                <div style={{ display: 'flex', flexDirection: 'row'}}>
                    <QuestionNumberContainer>
                        <Text style={{ color: '#575757' }}>{`${p.numero}.`}</Text>
                    </QuestionNumberContainer>
                     <LabelInput placeholder={'Digite a resposta aqui'} 
                        value={textAnswer} 
                        disabled={isView}
                        onChangeText={(event: any) =>{ onTextAnswerChange(event.target.value, p.id) }} />
                </div>)}</> })}
            </div>)}

            {perguntas.map((p: any, index: number)=>{
                return <>
                {isMobile && 
                (<QuestionContainer isMobile={true}>
                    {scalesLabel.length > 0 && (<div style={{ display: 'flex', flexDirection: 'row' }}>
                        <QuestionNumberContainer style={{ width: '8%'}}>
                            <Text style={{ color: '#575757' }}>{`${p.numero}.`}</Text>
                        </QuestionNumberContainer>
                        <QuestionBody isMobile={true}>
                            <Text style={{ fontSize: 18, color: '#575757' }}>{p.pergunta}</Text>
                        </QuestionBody>
                    </div>)}
                    {scalesLabel.length > 0?(<QuestionOptionContainer isMobile={true} style={{ flexDirection: 'column'}}>
                        {scalesLabel.map(answer=>{
                            return (<div style={{ flexDirection:'row', display: 'flex', marginBottom: 10 }}>
                            <QuestionOption 
                                isMobile={isMobile}
                                onClick={(isDemo || isView)? ()=>{}:()=>{ onClickOption(answer, index, p.id)}} 
                                selected={isNoneSelected? false : (isDemo? (answer.codigo === '4'? true : false) : isOptionSelected(answer, index, p.id))} isDemo={isDemo} isView={isView}>
                            <QuestionOptionText>{answer.codigo}</QuestionOptionText>
                        </QuestionOption>
                        <Text style={{ marginLeft: 20 }}>{answer.texto}</Text></div>)
                        })}
                    </QuestionOptionContainer>):(<div style={{ display: 'flex', flexDirection: 'row'}}>
                    <QuestionNumberContainer style={{ width: '8%' }}>
                        <Text style={{ color: '#575757' }}>{`${p.numero}.`}</Text>
                    </QuestionNumberContainer>
                        <LabelInput placeholder={'Digite a resposta aqui'} 
                            value={textAnswer} 
                            disabled={isView}
                            onChangeText={(event: any) =>{ onTextAnswerChange(event.target.value, p.id) }} />
                    </div>)}
                </QuestionContainer>)}</>
            })}
        </>
    )
    // --------------------------------------------------------
}

export default OMSQuestion